import * as React from "react";
import { Select, selectClasses } from "@mui/base/Select";
import { Option, optionClasses } from "@mui/base/Option";
import { Popper } from "@mui/base/Popper";
import { styled } from "@mui/system";
import { useDispatch } from "react-redux";
import { getPageNumber } from "../../redux/user/actions";

const StyledButton = styled("button")(
  () => `
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  width: 55px;
  background: #fff;
  border-radius: 0.75em;
  padding: 4px 5px;
  text-align: left;
  line-height: 1.5;
  color: black;
  font-weight: bold;
  margin-right: 0.5em;

  &:hover {
    background: #00000033;
  }

  &.${selectClasses.focusVisible} {
    outline: 3px solid #CB0C9F;
  }

  &.${selectClasses.expanded} {
    &::after {
      color: #0000008a;
      content: '▴';
    }
  }

  &::after {
    color: #0000008a;
    content: '▾';
    float: right;
  }
  `,
);

const StyledListbox = styled("ul")(
  () => `
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  padding: 4px 5px;
  margin: 1px 0;
  min-width: 55px;
  background: #fff;
  border: 1px solid #0000008a;
  border-radius: 0.75em;
  color: #0000008a;
  overflow: auto;
  outline: 0px;
  font-weight: bold;
  `,
);

const StyledOption = styled(Option)(
  () => `
  list-style: none;
  padding: 4px 5px;
  border-radius: 0.45em;
  cursor: default;

  &:last-of-type {
    border-bottom: none;
  }

  &.${optionClasses.selected} {
    background-color: #0000008a;
    color: #0000008a;
  }

  &.${optionClasses.highlighted} {
    background-color: #0000008a;
    color: #0000008a;
  }

  &.${optionClasses.highlighted}.${optionClasses.selected} {
    background-color: #0000008a;
    color: #fff;
  }

  &.${optionClasses.disabled} {
    color: #00000033;
  }

  &:hover:not(.${optionClasses.disabled}) {
    background-color:  #00000033;
    color: #fff;
  }
  `,
);

const StyledPopper = styled(Popper)`
  z-index: 1;
`;

const CustomSelect = React.forwardRef((props, ref) => {
  const slots = {
    root: StyledButton,
    listbox: StyledListbox,
    popper: StyledPopper,
    ...props.slots,
  };

  return <Select {...props} ref={ref} slots={slots} />;
});

const options = [
  { value: 10, label: "all" },
  { value: 15, label: "upsell" },
  { value: 20, label: "revenue" },
  { value: 25, label: "review" },
];

export default function ScDropdown() {
  const dispatch = useDispatch();
  const [filterPage, setFilterPage] = React.useState(10);

  React.useEffect(() => {
    dispatch(getPageNumber(filterPage));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterPage]);

  return (
    <CustomSelect value={filterPage} onChange={setFilterPage}>
      {options.map((val, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <StyledOption key={index} value={val.value}>
          {val.value}
        </StyledOption>
      ))}
    </CustomSelect>
  );
}
